import React, { useCallback, useEffect, useRef } from "react";
import { initRequestES } from "../../shared/common/learnositySpanishAuthorInit";
import { getRequest } from "../../../api/user.service";
export default function LearnosityPassageEditorES(props: any) {
  const isMounted = useRef(true);

  const initializationES = useCallback(() => {
    if (isMounted.current && document.getElementById("learnosity-authorES")) {
      let authorAppES;
      const callbacksES = {
        readyListener: function () {
          authorAppES.on("render:item", function () {
            props.authorAppParentES(authorAppES);
            const features = authorAppES.getItem().features;
            if (features.length == 0) {
              let passageData = {};
              if (
                props.widgetPsgDataES !== null &&
                props.widgetPsgDataES !== "" &&
                props.widgetPsgDataES !== undefined &&
                props.widgetPsgDataES["content"] !== ""
              ) {
                passageData = props.widgetPsgDataES;
              } else if (
                props.App !== undefined &&
                props.App.getWidget() !== undefined
              ) {
                passageData = props.App.getWidget();
              } else {
                passageData = {
                  type: "sharedpassage",
                  content: "",
                };
              }

              authorAppES.setWidget(passageData, "Passage");
              props.setWidgetPsgES(passageData);
            } else {
              const itemRef = authorAppES.getItem().item.reference;
              const widgetRef = features[features.length - 1].reference;
              if (!props.widgetPsgDataES) {
                props.setLoading(false);
                return authorAppES.navigate(
                  "items/" + itemRef + "/widgets/" + widgetRef + ""
                );
              } else {
                authorAppES.setWidget(props.widgetPsgDataES, "Passage");
              }
            }
            props.setLoading(false);
          });
          authorAppES.on("widgetedit:preview:changed", function (event) {
            props.setWidgetPsgES(authorAppES.getWidget());
          });
          authorAppES.on("widgetedit:widget:ready", function () {
            props.setIsLrnSpanishEditorLoaded(true);
            if (authorAppES.getWidget()["paginated_content"]) {
              props.setIsLrnSpanishPaginated(true);
            }
          });
        },
      };
      props.setLoading(true);
      const requestES = initRequestES(props.spanishPsgReferenceId, "features");
      getRequest("author", JSON.stringify(requestES)).then((response) => {
        if (response.data) {
          authorAppES = window["LearnosityAuthor"]?.init(
            response.data,
            "learnosity-authorES",
            callbacksES
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    initializationES();

    // Clean-up function
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div className="main-content">
      <div id="learnosity-authorES"></div>
    </div>
  );
}
